import {Menu} from '../types/left-menu.types';
import {resources} from "../../../models/resource/resources";

export const leftMenuConfig: Array<Menu> = [
  {
    type: 'default',
    id: resources['record-calendars-promotion-specialist'].key,
    iconName: 'home-icon',
    tag: resources['record-calendars-promotion-specialist'].name,
    availableRoles: ['ROLE_PROMOTION_SPECIALIST'],
    url: `/records/${resources['record-calendars-promotion-specialist'].path}`
  },
  {
    type: 'sub-menu',
    id: 'home',
    iconName: 'home-icon',
    tag: 'Главная',
    excludedRoles: [
      'ROLE_PROMOTION_SPECIALIST', 'ROLE_DESIGNER',
      'ROLE_PURCHASING_MANAGER', 'ROLE_MARKETPLACE_MANAGER',
      'ROLE_MARKETPLACE_HEAD', 'ROLE_BRAND_MANAGER'
    ],
    submenu: [
      {
        type: 'default',
        id: resources['record-lists'].key,
        iconName: '',
        tag: resources['record-lists'].name,
        url: `/records/${resources['record-lists'].path}`
      },
      {
        type: 'default',
        id: resources['record-calendars'].key,
        iconName: '',
        tag: resources['record-calendars'].name,
        url: `/records/${resources['record-calendars'].path}`
      },
      {
        type: 'default',
        id: resources['advertisement-integrations'].key,
        iconName: '',
        tag: resources['advertisement-integrations'].name,
        url: `/records/${resources['advertisement-integrations'].path}`,
        availableRoles: [ 'ROLE_ADMIN' ]
      },
      {
        type: 'default',
        id: resources['record-checks'].key,
        iconName: '',
        tag: resources['record-checks'].name,
        url: `/records/${resources['record-checks'].path}`
      },
      {
        type: 'default',
        id: resources['documents'].key,
        iconName: '',
        tag: resources['documents'].name,
        url: `/records/${resources['documents'].path}`
      },
      {
        type: 'default',
        id: resources['bloggers'].key,
        iconName: '',
        tag: resources['bloggers'].name,
        url: `/records/${resources['bloggers'].path}`
      },
      /*TODO: раскомментировать если включат telegram
      {
        type: 'default',
        id: resources['telegram'].key,
        iconName: '',
        tag: resources['telegram'].name,
        url: resources['telegram'].path
      },*/
      {
        type: 'default',
        id: resources['tech-tasks'].key,
        iconName: '',
        tag: resources['tech-tasks'].name,
        url: `/records/${resources['tech-tasks'].path}`
      }
    ]
  },
  {
    type: 'sub-menu',
    id: 'reports',
    iconName: 'table-icon',
    tag: 'Командные отчеты',
    excludedRoles: [ 'ROLE_PROMOTION_SPECIALIST', 'ROLE_DESIGNER', 'ROLE_PURCHASING_MANAGER', 'ROLE_BRAND_MANAGER' ],
    submenu: [
      {
        type: 'sub-menu',
        id: 'articles-reports',
        iconName: '',
        tag: 'Отчеты по артикулам',
        submenu: [
          {
            type: 'default',
            id: resources['article-day-reports'].key,
            iconName: '',
            tag: resources['article-day-reports'].name,
            url: `/records/${resources['article-day-reports'].path}`
          },
          {
            type: 'default',
            id: resources['article-week-reports'].key,
            iconName: '',
            tag: resources['article-week-reports'].name,
            url: `/records/${resources['article-week-reports'].path}`
          },
          {
            type: 'default',
            id: resources['article-month-reports'].key,
            iconName: '',
            tag: resources['article-month-reports'].name,
            url: `/records/${resources['article-month-reports'].path}`
          },
        ]
      },
      {
        type: 'sub-menu',
        id: 'group-reports',
        iconName: '',
        tag: 'Отчеты по категориям',
        submenu: [
          {
            type: 'default',
            id: resources['day-reports'].key,
            iconName: '',
            tag: resources['day-reports'].name,
            url: `/records/${resources['day-reports'].path}`
          },
          {
            type: 'default',
            id: 'week-report',
            iconName: '',
            tag: resources['week-reports'].name,
            url: `/records/${resources['week-reports'].path}`
          },
          {
            type: 'default',
            id: resources['month-reports'].key,
            iconName: '',
            tag: resources['month-reports'].name,
            url: `/records/${resources['month-reports'].path}`
          },
        ]
      },
      {
        type: 'default',
        id: resources['plan-fact-reports'].key,
        iconName: '',
        tag: resources['plan-fact-reports'].name,
        url: `/records/${resources['plan-fact-reports'].path}`
      },
      {
        type: 'default',
        id: resources['pulse-reports'].key,
        iconName: '',
        tag: resources['pulse-reports'].name,
        url: `/records/${resources['pulse-reports'].path}`
      },
      {
        type: 'default',
        id: resources['release-calendar'].key,
        iconName: '',
        tag: resources['release-calendar'].name,
        url: `/records/${resources['release-calendar'].path}`
      },
      {
        type: 'default',
        id: resources['price-level-configs'].key,
        iconName: '',
        tag: resources['price-level-configs'].name,
        url: `/records/${resources['price-level-configs'].path}`
      },
      {
        type: 'default',
        id: resources['price-levels'].key,
        iconName: '',
        tag: resources['price-levels'].name,
        url: `/records/${resources['price-levels'].path}`
      },
      {
        type: 'default',
        id: resources['mistakes'].key,
        iconName: '',
        tag: resources['mistakes'].name,
        url: `/records/${resources['mistakes'].path}`
      }
    ]
  },
  {
    type: 'sub-menu',
    id: 'databases',
    iconName: 'database-icon',
    tag: 'Базы данных',
    availableRoles: [
      'ROLE_ADMIN', 'ROLE_REVIEWER', 'ROLE_DOCUMENT_MANAGER',
      'ROLE_MARKETPLACE_MANAGER', 'ROLE_MARKETPLACE_HEAD'
    ],
    submenu: [
      {
        type: 'default',
        id: resources['products'].key,
        iconName: '',
        tag: resources['products'].name,
        url: `/records/${resources['products'].path}`
      },
      {
        type: 'default',
        id: resources['yandex-data'].key,
        iconName: '',
        tag: resources['yandex-data'].name,
        url: `/records/${resources['yandex-data'].path}`
      },
      {
        type: 'default',
        id: resources['social-media-metrics'].key,
        iconName: '',
        tag: resources['social-media-metrics'].name,
        url: `/records/${resources['social-media-metrics'].path}`
      },
      {
        type: "default",
        id: resources['customers'].path,
        iconName: '',
        tag: resources['customers'].name,
        url: `/records/${resources['customers'].path}`
      },

      {
        type: 'sub-menu',
        id: 'profit',
        iconName: '',
        tag: 'Прибыли',
        submenu: [
          {
            type: 'default',
            id: resources['google-profits'].key,
            iconName: '',
            tag: resources['google-profits'].name,
            url: `/records/${resources['google-profits'].path}`
          },
          {
            type: "default",
            id: resources['day-profits'].path,
            iconName: '',
            tag: resources['day-profits'].name,
            url: `/records/${resources['day-profits'].path}`
          },
          {
            type: "default",
            id: resources['profit-before-ads'].path,
            iconName: '',
            tag: resources['profit-before-ads'].name,
            url: `/records/${resources['profit-before-ads'].path}`
          }
        ]
      },
      {
        type: 'sub-menu',
        id: 'ozon',
        iconName: '',
        tag: 'Ozon',
        availableRoles: ['ROLE_ADMIN', 'ROLE_REVIEWER', 'ROLE_DOCUMENT_MANAGER'],
        submenu: [
          {
            type: 'default',
            id: resources['ozon-analytics'].key,
            iconName: '',
            tag: resources['ozon-analytics'].name,
            url: `/records/${resources['ozon-analytics'].path}`
          },
          {
            type: 'default',
            id: resources['ozon-advertisements'].key,
            iconName: '',
            tag: resources['ozon-advertisements'].name,
            url: `/records/${resources['ozon-advertisements'].path}`
          },
          {
            type: 'default',
            id: resources['ozon-utm'].key,
            iconName: '',
            tag: resources['ozon-utm'].name,
            url: `/records/${resources['ozon-utm'].path}`
          }
        ]
      },
      {
        type: 'sub-menu',
        id: 'wildberries',
        iconName: '',
        tag: 'Wildberries',
        availableRoles: ['ROLE_ADMIN', 'ROLE_REVIEWER', 'ROLE_DOCUMENT_MANAGER'],
        submenu: [
          {
            type: 'default',
            id: resources['wildberries-orders'].key,
            iconName: '',
            tag: resources['wildberries-orders'].name,
            url: `/records/${resources['wildberries-orders'].path}`
          },
          {
            type: 'default',
            id: resources['wildberries-advertisements'].key,
            iconName: '',
            tag: resources['wildberries-advertisements'].name,
            url: `/records/${resources['wildberries-advertisements'].path}`
          },
          {
            type: 'default',
            id: resources['wildberries-utm'].key,
            iconName: '',
            tag: resources['wildberries-utm'].name,
            url: `/records/${resources['wildberries-utm'].path}`
          },
          {
            type: 'default',
            id: resources['wildberries-campaigns'].key,
            iconName: '',
            tag: resources['wildberries-campaigns'].name,
            url: `/records/${resources['wildberries-campaigns'].path}`
          },
          {
            type: 'default',
            id: resources['wildberries-campaign-statistics'].key,
            iconName: '',
            tag: resources['wildberries-campaign-statistics'].name,
            url: `/records/${resources['wildberries-campaign-statistics'].path}`
          },
          {
            type: 'default',
            id: resources['wildberries-campaign-sales'].key,
            iconName: '',
            tag: resources['wildberries-campaign-sales'].name,
            url: `/records/${resources['wildberries-campaign-sales'].path}`
          },
          {
            type: 'default',
            id: resources['wildberries-net-profit'].key,
            iconName: '',
            tag: resources['wildberries-net-profit'].name,
            url: `/records/${resources['wildberries-net-profit'].path}`
          },
          {
            type: 'default',
            id: resources['wildberries-expenses'].key,
            iconName: '',
            tag: resources['wildberries-expenses'].name,
            url: `/records/${resources['wildberries-expenses'].path}`
          },
          {
            type: 'default',
            id: resources['wildberries-campaign-management'].key,
            iconName: '',
            tag: resources['wildberries-campaign-management'].name,
            url: `/records/${resources['wildberries-campaign-management'].path}`
          }
        ]
      }
    ]
  },
  {
    type: 'sub-menu',
    id: 'rating-reputation',
    iconName: 'reviews-icon',
    tag: 'Рейтинг и репутация',
    availableRoles: [
      'ROLE_ADMIN', 'ROLE_REVIEWER', 'ROLE_DOCUMENT_MANAGER',
      'ROLE_MARKETPLACE_MANAGER', 'ROLE_MARKETPLACE_HEAD'
    ],
    submenu: [
      {
        type: "default",
        id: resources['feedbacks'].path,
        iconName: '',
        tag: resources['feedbacks'].name,
        url: `/records/${resources['feedbacks'].path}`
      },
      {
        type: "default",
        id: resources['daily-feedback-reports'].path,
        iconName: '',
        tag: resources['daily-feedback-reports'].name,
        url: `/records/${resources['daily-feedback-reports'].path}`
      }
    ],
  },
  {
    type: 'sub-menu',
    id: 'marketplace-manager',
    iconName: 'marketplace-manager-icon',
    tag: 'Мен. Маркетплейсов',
    excludedRoles: ['ROLE_PROMOTION_SPECIALIST', 'ROLE_PURCHASING_MANAGER' ],
    submenu: [
      {
        type: 'default',
        id: resources['hypotheses'].key,
        iconName: 'hypothesis-icon',
        tag: resources['hypotheses'].name,
        excludedRoles: [ 'ROLE_DESIGNER', 'ROLE_BRAND_MANAGER' ],
        url: `/records/${resources['hypotheses'].path}`
      },
      {
        type: 'default',
        id: resources['notes'].key,
        iconName: 'notes-icon',
        tag: resources['notes'].name,
        excludedRoles: [ 'ROLE_DESIGNER', 'ROLE_BRAND_MANAGER' ],
        url: `/records/${resources['notes'].path}`
      },
      {
        type: 'default',
        id: resources['rrc-controls'].key,
        iconName: '',
        tag: resources['rrc-controls'].name,
        excludedRoles: [ 'ROLE_DESIGNER', 'ROLE_BRAND_MANAGER' ],
        url: `/records/${resources['rrc-controls'].path}`
      },
      {
        type: 'default',
        id: resources['rrc-limits'].key,
        iconName: '',
        tag: resources['rrc-limits'].name,
        excludedRoles: [ 'ROLE_DESIGNER', 'ROLE_BRAND_MANAGER' ],
        url: `/records/${resources['rrc-limits'].path}`
      },
      {
        type: 'default',
        id: resources['wildberries-product-cards'].key,
        iconName: '',
        tag: resources['wildberries-product-cards'].name,
        url: `/records/${resources['wildberries-product-cards'].path}`
      },
      {
        type: 'default',
        id: resources['ozon-products'].key,
        iconName: '',
        tag: resources['ozon-products'].name,
        url: `/records/${resources['ozon-products'].path}`
      },
      {
        type: 'default',
        id: resources['competitor-brands'].key,
        iconName: '',
        tag: resources['competitor-brands'].name,
        excludedRoles: [ 'ROLE_DESIGNER', 'ROLE_BRAND_MANAGER' ],
        url: `/records/${resources['competitor-brands'].path}`
      },
      {
        type: 'default',
        id: resources['product-cards'].key,
        iconName: '',
        tag: resources['product-cards'].name,
        excludedRoles: [ 'ROLE_DESIGNER', 'ROLE_BRAND_MANAGER' ],
        url: `/records/${resources['product-cards'].path}`
      },
      {
        type: 'default',
        id: resources['competitor-article-prices'].key,
        iconName: '',
        tag: resources['competitor-article-prices'].name,
        excludedRoles: [ 'ROLE_DESIGNER', 'ROLE_BRAND_MANAGER' ],
        url: `/records/${resources['competitor-article-prices'].path}`
      },
      {
        type: 'default',
        id: resources['competitor-articles'].key,
        iconName: '',
        tag: resources['competitor-articles'].name,
        excludedRoles: [ 'ROLE_DESIGNER', 'ROLE_BRAND_MANAGER' ],
        url: `/records/${resources['competitor-articles'].path}`
      }
    ]
  },
  {
    type: 'sub-menu',
    id: 'purchasing-product-managers',
    iconName: 'purchasing-product-managers-icon',
    tag: 'Закупки и Продуктологи',
    excludedRoles: [ 'ROLE_PROMOTION_SPECIALIST' ],
    submenu: [
      {
        type: 'default',
        id: resources['technical-parameters'].key,
        iconName: '',
        tag: resources['technical-parameters'].name,
        excludedRoles: [ 'ROLE_DESIGNER', 'ROLE_BRAND_MANAGER' ],
        url: `/records/${resources['technical-parameters'].path}`
      },
      {
        type: 'default',
        id: resources['product-packages'].key,
        iconName: '',
        tag: resources['product-packages'].name,
        excludedRoles: [ 'ROLE_DESIGNER', 'ROLE_BRAND_MANAGER' ],
        url: `/records/${resources['product-packages'].path}`
      }
    ]
  },
  {
    type: 'sub-menu',
    id: 'admin',
    iconName: 'label-icon',
    tag: 'Админка',
    availableRoles: ['ROLE_ADMIN'],
    submenu: [
      {
        type: 'default',
        id: 'dropdown-settings',
        iconName: '',
        tag: 'Настройки дропдаунов',
        url: '/dropdown-settings'
      },
      {
        type: 'default',
        id: resources['users'].key,
        iconName: '',
        tag: resources['users'].name,
        url: `/records/${resources['users'].path}`
      },
      {
        type: 'default',
        id: resources['telegram-accounts'].key,
        iconName: '',
        tag: resources['telegram-accounts'].name,
        url: `/records/${resources['telegram-accounts'].path}`
      },
      {
        type: 'default',
        id: 'development',
        iconName: '',
        tag: 'Разработка',
        url: '/development'
      },
      {
        type: 'default',
        id: resources['application-events'].key,
        iconName: '',
        tag: resources['application-events'].name,
        url: `/records/${resources['application-events'].path}`
      }
    ],
  },
  {
    type: 'default',
    id: 'logout',
    iconName: 'logout-icon',
    tag: 'Выйти',
    url: '/login'
  }
]
